export default __webpack_public_path__ + "static/media/IMG_9460.fc034dc1.jpeg";